import React from "react";
import {Accordion, Button, ButtonGroup, Col, Form, Image, Nav, Row, Tab, Card} from '@themesberg/react-bootstrap';
import BasePage from "../base/BasePage";
import label from "enqc-utilities/src/label/Label"
import Endpoint from "enqc-utilities/src/api/Endpoint";
import {isEmpty, parseDate} from "enqc-utilities/src/utils/Utilities";
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import TableSortOption from "../../components/input/TableSortOption";
import SortOption from "enqc-utilities/src/model/SortOption";
import FilterButton from "../../components/FilterButton";
import UserFilterModal from "../../components/UserFilterModal";
import ModelCategoryFilterModal from "../../components/ModelCategoryFilterModal";
import DateFilterButton from "../../components/DateFilterButton";
import {DD_MM_YYYY} from "../../utils/Global";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCalendarAlt, faFileExcel, faFilter} from "@fortawesome/free-solid-svg-icons";
import AssemblyTable from "./AssemblyTable";
import ModelFilterModal from "../../components/ModelFilterModal";
import SearchBasicForm from "../../components/input/SearchBasicForm";

// let assemblyTableRefs = React.createRef();

class AssemblyPage extends BasePage {
    constructor(props) {
        super(props);
        this.assemblyTableRefs = []
        this.state = {
            assemblyStatuses:this.defaultAssemblyStatus(),
            defaultActiveTab:"0",
            activeTab:0,
            categoryFilterModal:false,
            modelFilterModal:false,
            userFilter:false,
            deviceFilter:false,
            filteredSmartDevices:new Set([]),
            filteredUsers:new Set([]),
            filteredModelCategories:new Set([]),
            filteredModels:new Set([]),
            selectedAssembly:{},
            assemblyModal:false,
            assemblyHistoryModal:false,
            color:'blue',
            tabDataSize:{},
            startCreatedAt:undefined,
            endCreatedAt:undefined,
            startUpdatedAt:undefined,
            endUpdatedAt:undefined,
        }
    }

    componentDidMount() {
        super.componentDidMount();
        if(this.props?.navBar?.current){
            this.props.navBar.current.updateNavBarItems([AssemblyPage.PAGE_CONF])
        }

        this.closePreLoader()
        this.fetchAssemblyStatus()
    }
    
    defaultAssemblyStatus(){
        let assemblyStatuses = []
        let allassemblyStatus = {
            id:0,
            label:label.All,
            active:true,
            iconLink:ApplicationIcons.Icons.lines,
        }
        assemblyStatuses.push(allassemblyStatus)
        return assemblyStatuses
    }

    fetchAssemblyStatus = () => {
        let {assemblyStatuses, activeTab, defaultActiveTab} = this.state
        this.get(Endpoint.API.ASSEMBLY_STATUSES, {
            params :{
                sortir: "id",
                ascending:true,
            }
        }, null, response=>{
            if(response.code===200){
                assemblyStatuses = this.defaultAssemblyStatus();
                assemblyStatuses.push(...response.data)
                let tabDataSize = {}
                for(let assemblyStatus of assemblyStatuses){
                    tabDataSize[assemblyStatus.id] = 0
                }
                this.setState({assemblyStatuses:assemblyStatuses, tabDataSize},() => this.forceUpdate())
            }else{
                // this.props.history.goBack();
            }
        }, true, true)
    }

    fetchAssemblies(downloadExcel){
        let {search, sortOption, activeTab, filteredUsers, filteredModelCategories, filteredModels, startCreatedAt, endCreatedAt, startUpdatedAt, endUpdatedAt} = this.state
        this.setState({activeTab:downloadExcel?activeTab:0},
            () => {
                if(this.assemblyTableRefs){
                    this.assemblyTableRefs.forEach((assemblyTableRef)=>{
                        assemblyTableRef.fetchAssemblies(search, sortOption, filteredUsers, filteredModelCategories, filteredModels, startCreatedAt, endCreatedAt, startUpdatedAt, endUpdatedAt, downloadExcel)
                    })
                }
            })
    }

    tabDataCallback(id, size){
        let {tabDataSize} = this.state
        tabDataSize[id] = size
        this.setState({tabDataSize}, () => this.forceUpdate())
    }

    render() {
        let {assemblyStatuses, defaultActiveTab, activeTab,
            selectedAssembly, assemblyModal, userFilter, deviceFilter, categoryFilterModal, modelFilterModal,
            filteredModelCategories, filteredModels, filteredSmartDevices, filteredUsers,
            tabDataSize,assemblyHistoryModal,
            startCreatedAt, endCreatedAt, startUpdatedAt, endUpdatedAt,
            pageElement, totalPage, totalElement, sortOption} = this.state

        let dateFilterActive = false
        if(startCreatedAt || endCreatedAt || startUpdatedAt || endUpdatedAt){
            dateFilterActive = true
        }

        return (
            <>
                <ModelCategoryFilterModal
                    show={categoryFilterModal}
                    selectedModelCategories={filteredModelCategories}
                    onClose={()=>{
                        this.setState({categoryFilterModal:false})
                    }}
                    onSelect={(selectedModelCategories)=>{
                        this.setState({categoryFilterModal:false, filteredModelCategories:selectedModelCategories}, () => {
                            this.fetchAssemblies()
                        })
                    }}/>
                <ModelFilterModal
                    show={modelFilterModal}
                    selectedModels={filteredModels}
                    selectedModelCategories={filteredModelCategories}
                    onClose={()=>{
                        this.setState({modelFilterModal:false})
                    }}
                    onSelect={(selectedModels)=>{
                        this.setState({modelFilterModal:false, filteredModels:selectedModels}, () => {
                            this.fetchAssemblies()
                        })
                    }}/>
                <UserFilterModal
                    show={userFilter}
                    selectedUsers={filteredUsers}
                    onClose={()=>{
                        this.setState({userFilter:false})
                    }}
                    onSelect={(selectedUsers)=>{
                        this.setState({userFilter:false, filteredUsers:selectedUsers}, () => {
                            this.fetchAssemblies()
                        })
                    }}/>
                <Row>
                    <Col>
                        {this.renderHeader()}
                        {this.renderSearch()}
                        {this.renderTable()}
                    </Col>
                </Row>
            </>
        );
    }

    renderHeader(){
        let {filteredModelCategories, filteredModels, filteredUsers,
            startCreatedAt, endCreatedAt, startUpdatedAt, endUpdatedAt, sortOption} = this.state

        let dateFilterActive = false
        if(startCreatedAt || endCreatedAt || startUpdatedAt || endUpdatedAt){
            dateFilterActive = true
        }

        return(
            <React.Fragment>
                <Accordion className="mb-4"  defaultActiveKey={['0']} alwaysOpen>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header className="bg-light rounded"><FontAwesomeIcon size="sm" icon={faFilter}/>&nbsp;{label.ClickToExpandFilterContent}</Accordion.Header>
                        <Accordion.Body>
                            <Row>
                                <Col>
                                    <Row className="mb-0 align-items-center">
                                        <Col xs={12} sm={12} md={12} xl={12} className="p-2 text-right">
                                            <ButtonGroup className="d-flex font-small">
                                                <FilterButton
                                                    label={label.CategoryFilter}
                                                    active={filteredModelCategories.size>0}
                                                    onReset={() => {
                                                        this.setState({
                                                            filteredModelCategories:new Set([])
                                                        }, () => {
                                                            this.fetchAssemblies()
                                                        })
                                                    }}
                                                    onClick={() => {
                                                        this.setState({categoryFilterModal:true})
                                                    }}/>
                                                &nbsp;
                                                &nbsp;
                                                <FilterButton
                                                    label={label.ModelFilter}
                                                    active={filteredModels.size>0}
                                                    onReset={() => {
                                                        this.setState({
                                                            filteredModels:new Set([])
                                                        }, () => {
                                                            this.fetchAssemblies()
                                                        })
                                                    }}
                                                    onClick={() => {
                                                        this.setState({modelFilterModal:true})
                                                    }}/>
                                                &nbsp;
                                                &nbsp;
                                                <FilterButton
                                                    label={label.UserFilter}
                                                    active={filteredUsers.size>0}
                                                    onReset={() => {
                                                        this.setState({
                                                            filteredUsers:new Set([])
                                                        }, () => {
                                                            this.fetchAssemblies()
                                                        })
                                                    }}
                                                    onClick={() => {
                                                        this.setState({userFilter:true})
                                                    }}/>
                                            </ButtonGroup>
                                        </Col>
                                    </Row>
                                    <Row className="mb-0">
                                        <Col xs={6} sm={6} md={4} className="border-end p-3 bg-gray-300 mb-0">
                                            <Row>
                                                <Col>
                                                    <Form.Label>{label.CreatingDate}</Form.Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12} sm={12} md={12} lg={6} className="mb-2">
                                                    <DateFilterButton
                                                        title={startCreatedAt?parseDate(startCreatedAt, DD_MM_YYYY):label.StartDate}
                                                        maximumDate={endCreatedAt}
                                                        value={startCreatedAt}
                                                        onSelect={(value)=>{
                                                            this.setState({startCreatedAt:value}, () => {
                                                                this.fetchAssemblies()
                                                            })
                                                        }}/>
                                                </Col>
                                                <Col xs={12} sm={12} md={12} lg={6} className="mb-2">
                                                    <DateFilterButton
                                                        title={endCreatedAt?parseDate(endCreatedAt, DD_MM_YYYY):label.EndDate}
                                                        minimumDate={startCreatedAt}
                                                        value={endCreatedAt}
                                                        onSelect={(value)=>{
                                                            this.setState({endCreatedAt:value}, () => {
                                                                this.fetchAssemblies()
                                                            })
                                                        }}/>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={6} sm={6}  md={4} className="border-end p-3 bg-gradient-gray-400 mb-0">
                                            <Row>
                                                <Col>
                                                    <Form.Label>{label.UpdatingDate}</Form.Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12} sm={12} md={12} lg={6} className="mb-2">
                                                    <DateFilterButton
                                                        title={startUpdatedAt?parseDate(startUpdatedAt, DD_MM_YYYY):label.StartDate}
                                                        maximumDate={endUpdatedAt}
                                                        value={startUpdatedAt}
                                                        onSelect={(value)=>{
                                                            this.setState({startUpdatedAt:value}, () => {
                                                                this.fetchAssemblies()
                                                            })
                                                        }}/>
                                                </Col>
                                                <Col xs={12} sm={12} md={12} lg={6} className="mb-2">
                                                    <DateFilterButton
                                                        title={endUpdatedAt?parseDate(endUpdatedAt, DD_MM_YYYY):label.EndDate}
                                                        minimumDate={startUpdatedAt}
                                                        value={endUpdatedAt}
                                                        onSelect={(value)=>{
                                                            this.setState({endUpdatedAt:value}, () => {
                                                                this.fetchAssemblies()
                                                            })
                                                        }}/>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={12} sm={12} md={4} className="ps-3 pe-3 text-center align-content-center">
                                            <Row>
                                                <Col sm={6} xs={6} md={12} className="mb-3">
                                                    <Button
                                                        block
                                                        size="sm"
                                                        className="w-100"
                                                        variant={dateFilterActive?"outline-danger":"outline-dark"}
                                                        style={{backgroundColor:'white', color:'black'}} disabled={!dateFilterActive}
                                                        onClick={event => {
                                                            this.setState({startCreatedAt:undefined, endCreatedAt:undefined, startUpdatedAt:undefined, endUpdatedAt:undefined}, () => {
                                                                this.fetchAssemblies()
                                                            })
                                                        }}>
                                                        <FontAwesomeIcon icon={faCalendarAlt} size="sm"/>&nbsp;
                                                        {label.ResetFilterDate}
                                                    </Button>
                                                </Col>
                                                <Col sm={6} xs={6}  md={12} className="mb-3">
                                                    <Button
                                                        block
                                                        size="sm"
                                                        className="w-100"
                                                        variant={"outline-success"}
                                                        style={{backgroundColor:'white', color:'green'}}
                                                        onClick={event => {
                                                            this.fetchAssemblies(true)
                                                        }}>
                                                        <FontAwesomeIcon icon={faFileExcel} size="sm"/>&nbsp;
                                                        {label.DownloadExcel}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </React.Fragment>
        )
    }

    renderSearch(){
        let {sortOption} = this.state

        return(
            <Row>
                <Col xs={12} sm={12} md={6} xl={5} className="mb-3">
                    <div className='d-flex align-items-center'>
                        <SearchBasicForm
                            onEnter={(search) => {
                                this.setState({search}, () => {
                                    this.fetchAssemblies()
                                })
                            }} onEmpty={() => {
                            this.setState({search:""},() => {
                                this.fetchAssemblies()
                            })
                        }}/>
                        &nbsp;&nbsp;
                        <TableSortOption
                            sortOptions={
                                [
                                    SortOption.init(label.Latest,"ay.created",false),
                                    SortOption.init(label.Oldest,"ay.created",true),
                                ]
                            }
                            sortOption={sortOption}
                            placeholder={label.SortBy}
                            onSelect={(sortOption) => {
                                this.setState({sortOption},() => {
                                    this.fetchAssemblies()
                                })
                            }}
                            onReset={() => {
                                this.setState({sortOption:{}},() => {
                                    this.fetchAssemblies()
                                })
                            }}/>
                    </div>
                </Col>
            </Row>
        )
    }

    renderTable(){
        let {assemblyStatuses, defaultActiveTab, activeTab, tabDataSize, startCreatedAt, endCreatedAt, startUpdatedAt, endUpdatedAt} = this.state
        return(
            <Row>
                <Col className="p-2">
                    {
                        !isEmpty(defaultActiveTab)?
                            (
                                <Tab.Container defaultActiveKey={defaultActiveTab}>
                                    <Nav fill variant="tabs" className="flex-fill flex-sm-row p-0 m-0">
                                        {
                                            assemblyStatuses.map((item, index)=>(
                                                <Nav.Link
                                                    eventKey={item.id}
                                                    className={"mb-2 mx-1 p-2 text-black "+(item.id === activeTab?'bg-soft-green':'bg-white')}
                                                    onSelect={eventKey => {
                                                        this.setState({activeTab:item.id})
                                                    }}
                                                    disabled={!item.active}>
                                                    <img style={{width:'24px'}} src={item.iconLink}/>&nbsp;
                                                    <span style={{color:(item.id === activeTab?'white':item.color)}}>{item.label}</span>
                                                    <span style={{color:(item.id === activeTab?'white':item.color), fontWeight:'bold'}}>{" ("+tabDataSize[item.id]+")"}</span>
                                                </Nav.Link>

                                            ))
                                        }
                                    </Nav>
                                    <Tab.Content>
                                        {
                                            assemblyStatuses.map((assemblyStatus, index)=>(
                                                <Tab.Pane eventKey={assemblyStatus.id} className="py-4">
                                                    <AssemblyTable
                                                        {...this.props}
                                                        showProcessing={this.props.showProcessing}
                                                        closeProcessing={this.props.closeProcessing}
                                                        ref={(ref)=>{
                                                            this.assemblyTableRefs[index] = ref
                                                        }}
                                                        show={assemblyStatus.id === activeTab}
                                                        assemblyStatus={assemblyStatus}
                                                        onSelect={(selectedAssembly) => {
                                                            this.setState({selectedAssembly, assemblyModal:true})
                                                        }}
                                                        tabDataCallback={(id, size)=>{
                                                            this.tabDataCallback(id, size)
                                                        }}
                                                    />
                                                </Tab.Pane>
                                            ))
                                        }
                                    </Tab.Content>

                                </Tab.Container>
                            )
                            :
                            (null)
                    }
                </Col>
            </Row>
        )
    }

}
// export default Object.assign(assemblyPage, {ENDPOINT : "/assemblies"})

const ENDPOINT = "/assemblies"
const TITLE = label.Assemblies
const PAGE = {ENDPOINT: ENDPOINT, PAGE_CONF: {ENDPOINT, TITLE}}
export default Object.assign(AssemblyPage, PAGE)


